import {
  Types as newsActionTypes,
  Creators as newsActionCreators
} from '../app/news/duck';

import {
  Types as singleNewsActionTypes,
  Creators as singleNewsActionCreators
} from '../app/single-article/single-news/duck';

import {
  Types as reviewsActionTypes,
  Creators as reviewsActionCreators
} from '../app/reviews/duck';

import {
  Types as singleReviewActionTypes,
  Creators as singleReviewActionCreators
} from '../app/single-article/single-review/duck';

import {
  Types as t3ActionTypes,
  Creators as t3ActionCreators
} from '../app/how-to-(T3)/duck';

import {
  Types as singleT3ActionTypes,
  Creators as singleT3ActionCreators
} from '../app/single-article/single-t3/duck';

import {
  Types as internetActionTypes,
  Creators as internetActionCreators
} from '../app/internet/duck';

// import {
//   Types as bestOfActionTypes,
//   Creators as bestOfActionCreators
// } from '../app/best-of/duck';

// import {
//   Types as singleBestOfActionTypes,
//   Creators as singleBestOfActionCreators
// } from '../app/single-article/single-best-of/duck';

import {
  Types as authorInfoActionTypes,
  Creators as authorInfoActionCreators
} from '../app/author/duck';

import {
  Types as tagsPostListTypes,
  Creators as tagsPostListCreators
} from '../app/tags/duck';

import {
  Types as homeActionTypes,
  Creators as homeActionCreators
} from '../app/home/duck';

import {
  Types as galleryActionTypes,
  Creators as galleryActionCreators
} from '../app/gallery/duck';

import {
  Types as searchActionTypes,
  Creators as searchActionCreators
} from '../app/common/Search/duck';

const Types = {
  ...newsActionTypes,
  ...singleNewsActionTypes,
  ...reviewsActionTypes,
  ...singleReviewActionTypes,
  ...t3ActionTypes,
  ...singleT3ActionTypes,
  ...internetActionTypes,
  // ...bestOfActionTypes,
  // ...singleBestOfActionTypes,
  ...authorInfoActionTypes,
  ...tagsPostListTypes,
  ...homeActionTypes,
  ...galleryActionTypes,
  ...searchActionTypes
};

const Creators = {
  ...newsActionCreators,
  ...singleNewsActionCreators,
  ...reviewsActionCreators,
  ...singleReviewActionCreators,
  ...t3ActionCreators,
  ...singleT3ActionCreators,
  ...internetActionCreators,
  // ...bestOfActionCreators,
  // ...singleBestOfActionCreators,
  ...authorInfoActionCreators,
  ...tagsPostListCreators,
  ...homeActionCreators,
  ...galleryActionCreators,
  ...searchActionCreators
};

export { Types, Creators };
